import { render, staticRenderFns } from "./AssetPicker.vue?vue&type=template&id=4ce7845e&scoped=true&"
import script from "./AssetPicker.vue?vue&type=script&lang=js&"
export * from "./AssetPicker.vue?vue&type=script&lang=js&"
import style0 from "./AssetPicker.vue?vue&type=style&index=0&id=4ce7845e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce7845e",
  null
  
)

export default component.exports